const STATUS_ICONS: Record<string, { color: string; label: string }> = {
  healthy: { color: "text-green-400", label: "Healthy" },
  degraded: { color: "text-yellow-400", label: "Degraded" },
  unavailable: { color: "text-red-400", label: "Unavailable" },
};

export function SystemHealthWidget({ data }: { data: Record<string, unknown> }) {
  const status = (data.status ?? "unknown") as string;
  const services = (data.services ?? {}) as Record<string, string>;
  const timestamp = data.timestamp as string | undefined;

  const statusInfo = STATUS_ICONS[status] ?? { color: "text-gray-400", label: status };

  return (
    <div className="space-y-3">
      {/* Overall status */}
      <div className="flex items-center gap-2 pb-2 border-b border-gray-700/50">
        <div className={`w-3 h-3 rounded-full ${status === "healthy" ? "bg-green-500" : status === "degraded" ? "bg-yellow-500" : "bg-red-500"}`} />
        <span className={`font-medium ${statusInfo.color}`}>{statusInfo.label}</span>
        {timestamp && (
          <span className="text-xs text-gray-600 ml-auto">
            {new Date(timestamp).toLocaleTimeString()}
          </span>
        )}
      </div>

      {/* Service breakdown */}
      <div className="space-y-1.5">
        {Object.entries(services).map(([name, value]) => {
          const svcStatus = STATUS_ICONS[value] ?? { color: "text-gray-400", label: value };
          return (
            <div key={name} className="flex items-center justify-between text-xs">
              <span className="text-gray-400">{name.replace(/_/g, " ")}</span>
              <span className={svcStatus.color}>{svcStatus.label}</span>
            </div>
          );
        })}
      </div>

      {Object.keys(services).length === 0 && (
        <div className="text-gray-500 text-xs text-center">No service data</div>
      )}
    </div>
  );
}
